import { Survey } from './survey';
import { Page } from './page';

export class NavigationRule {
  id: number;
  key: string;
  order: number;
  condition: string;
  target_page: string;

  private _survey: Survey;

  getSurvey(): Survey {
    return this._survey;
  }

  setSurvey(survey: Survey) {
    this._survey = survey;
  }

  private _page: Page;

  getPage(): Page {
    return this._page;
  }

  setPage(page: Page) {
    this._page = page;
  }

  toJSON(): Object {
    // create an instance of the NavigationRule class
    let navigation_rule = Object.create(NavigationRule.prototype);
    // copy all the fields from the json object
    navigation_rule.key = this.key;
    navigation_rule.condition = this.condition;
    navigation_rule.target_page = this.target_page;

    return navigation_rule;
  }

  static fromJSON(navigation_rule_json): NavigationRule {
    // create an instance of the NavigationRule class
    let navigation_rule = Object.create(NavigationRule.prototype);
    // copy all the fields from the json object
    let obj = Object.assign(navigation_rule, navigation_rule_json);
    return navigation_rule;

  }
}

